import React, { useState, useEffect } from "react";
import AppShell from "./components/AppShell";
import Login from "./views/Login";
import LauncherView from "./views/LauncherView";
import DashboardKPIView from "./views/DashboardKPIView";
import UsersManagement from "./views/UsersManagement";
import FleetView from "./views/FleetView";
import RidesView from "./views/RidesView";
import TariffsView from "./views/TariffsView";
import BotView from "./views/BotView";
import BotLogsView from "./views/BotLogsView";
import ReportsView from "./views/ReportsView";
import SOSView from "./views/SOSView";
import LiveMapView from "./views/LiveMapView";
import AdminBulkView from "./views/AdminBulkView";
import DedupStateView from "./views/DedupStateView";
import PricingBandsView from "./views/PricingBandsView";
import PromotionsView from "./views/PromotionsView";
import NotificationsBroadcastView from "./views/NotificationsBroadcastView";
import POIsView from "./views/POIsView";
import PrivacyPolicyView from "./views/PrivacyPolicyView";
import DeleteAccountView from "./views/DeleteAccountView";
import { ThemeProvider } from "./context/ThemeContext";
import { authApi } from "./api/client";
import "./App.css";

function AppInner() {
  // Rutas públicas: /politica-privacidad, /privacy-policy, /delete-account
  // — no requieren login (Google Play las audita).
  const path = typeof window !== "undefined" ? window.location.pathname : "";
  const isPublicPolicy = path === "/politica-privacidad" || path === "/privacy-policy";
  const isDeleteAccount = path === "/delete-account" || path === "/eliminar-cuenta";
  const isPublic = isPublicPolicy || isDeleteAccount;

  const [section, setSection] = useState("launcher");
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (isPublic) { setChecking(false); return; }
    authApi.me()
      .then(setUser)
      .catch(() => setUser(null))
      .finally(() => setChecking(false));
  }, [isPublic]);

  if (isPublicPolicy) return <PrivacyPolicyView />;
  if (isDeleteAccount) return <DeleteAccountView />;

  const handleLogin = (u) => setUser(u);
  const handleLogout = async () => {
    try { await authApi.logout(); } catch { /* ignore */ }
    setUser(null);
    setSection("launcher");
  };

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="mdd-mesh-bg" />
        <div className="mdd-grid-overlay" />
        <div className="text-mdd-muted text-sm font-mono animate-pulse">Cargando sistema...</div>
      </div>
    );
  }
  if (!user) return <Login onLogin={handleLogin} />;

  return (
    <AppShell active={section} onNavigate={setSection} user={user} onLogout={handleLogout}>
      {section === "launcher" && <LauncherView onNavigate={setSection} user={user} />}
      {section === "kpis" && <DashboardKPIView />}
      {section === "users" && <UsersManagement />}
      {section === "fleet" && <FleetView />}
      {section === "rides" && <RidesView />}
      {section === "tariffs" && <TariffsView />}
      {section === "bot" && <BotView />}
      {section === "botlogs" && <BotLogsView />}
      {section === "reports" && <ReportsView />}
      {section === "sos" && <SOSView />}
      {section === "live" && <LiveMapView />}
      {section === "bulk" && <AdminBulkView />}
      {section === "pricing" && <PricingBandsView />}
      {section === "promos" && <PromotionsView />}
      {section === "notify" && <NotificationsBroadcastView />}
      {section === "pois" && <POIsView />}
      {section === "dedup" && user?.role === "super_admin" && <DedupStateView />}
    </AppShell>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppInner />
    </ThemeProvider>
  );
}

export default App;
